module.exports = __webpack_public_path__ + "static/media/Galdisa_chipotle_corn.87cee265.pdf";